export const IgnoredErrors = {
  LOGIN_REQUIRED: { key: "LOGIN_REQUIRED", value: "You must login to continue" },
  REFRESH_REQUIRED: {
    key: "REFRESH_REQUIRED",
    value: "A problem occurred please refresh and try again",
  },
  ACCESS_DENIED: { key: "ACCESS_DENIED", value: "Access denied" },
  PAGE_NOT_FOUND: { key: "PAGE_NOT_FOUND", value: "Page could not be found" },
  METRICS_WARMING: {
    key: "METRICS_WARMING",
    value: "We're still fetching your data. Please try again in a few minutes.",
  },
  METRICS_WARM_FAILED: {
    key: "METRICS_WARM_FAILED",
    value: "We couldn't prepare your metrics. Please try again in a few minutes.",
  },
};

export const IgnoredErrorMessages = [
  IgnoredErrors.LOGIN_REQUIRED.value,
  IgnoredErrors.ACCESS_DENIED.value,
  IgnoredErrors.PAGE_NOT_FOUND.value,
  // RE-1459 warm states are operational, not errors (PULSE-4W9)
  IgnoredErrors.METRICS_WARMING.value,
  IgnoredErrors.METRICS_WARM_FAILED.value,
];
